export default "__VITE_ASSET__PiGvDMmO__"